export { default as GloWinCommon } from 'lowcode/plugins/glo-bar-win/glo-win-common/indexS';
